/* src/app/modules/spare-parts/highest-consumed-graph/highest-consumed-graph.component.scss */
:host {
  display: block;
}
#graph {
  width: 100%;
  height: 220px;
}
/*# sourceMappingURL=highest-consumed-graph.component.css.map */
